import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCalendarMinus = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.984 17.363h16.041M15.635 11.246v2.5M8.364 11.246v2.5M3.9 21.039v-4.194c0-2.706 1.65-4.178 4.294-4.178h7.62c2.651 0 4.294 1.472 4.286 4.178v4.194M8.36 20.4h.01M11.995 20.4h.01M15.63 20.4h.01M14.713 5.68H8.975"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCalendarMinus);
export default ForwardRef;
